import { createBlueprint as e } from "@made-people/blueprint";
const t = e({
  slots: {
    base: "overflow-x-auto rounded-lg shadow",
    table: "min-w-full border-collapse",
    headingWrapper: "bg-gray-100",
    heading: "px-4 py-2 text-xs font-bold text-gray-700 uppercase border-b border-gray-200",
    body: "bg-white divide-y divide-gray-200",
    row: "hover:bg-gray-50 even:bg-gray-50",
    item: "px-4 py-2 text-sm text-gray-600 border-b border-gray-200 text-center"
  },
  variants: {}
});
export {
  t as tableBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
